import React, { useState, useEffect } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import './App.css';

// Asset imports
import headerLogo from '../assets/MAIN/header_logo.png';
import mainBack from '../assets/MAIN/mainback.png';
import portfolioImage from '../assets/MAIN/PORTFOLIO.png';
import aboutMeImage from '../assets/MAIN/ABOUT_ME.png';
import resumePDF from '../assets/MAIN/Dzhevelik_CV.pdf';

// Gallery assets
import mapiGallery from '../assets/MAIN/Mapi_gallery.png';
import mapiGallery2 from '../assets/MAIN/Mapi_gallery2.png';
import mohaveGallery from '../assets/MAIN/Mohave_gallery.png';
import yuzuGallery from '../assets/MAIN/Yuzu_gallery.png';

// Navigation assets
import leftArrowActive from '../assets/MAIN/Left_arrow_Active.png';
import leftArrowInactive from '../assets/MAIN/Left_arrow_inactive.png';

// 2048 game assets
import back2048 from '../assets/MAIN/2048/BACK_2048.png';
import tile1 from '../assets/MAIN/2048/2048_1.png';
import tile2 from '../assets/MAIN/2048/2048_2.png';
import tile3 from '../assets/MAIN/2048/2048_3.png';
import tile4 from '../assets/MAIN/2048/2048_4.png';
import tile5 from '../assets/MAIN/2048/2048_5.png';
import tile6 from '../assets/MAIN/2048/2048_6.png';
import tile7 from '../assets/MAIN/2048/2048_7.png';
import tile8 from '../assets/MAIN/2048/2048_8.png';
import tile9 from '../assets/MAIN/2048/2048_9.png';
import tile10 from '../assets/MAIN/2048/2048_10.png';
import tile11 from '../assets/MAIN/2048/2048_11.png';
import topNewGame from '../assets/MAIN/Topnewgame.png';
import pressToPlay from '../assets/MAIN/2048/Presstoplay.png';

// Page components
import Mapi from './Mapi';
import MapiWeb from './MapiWeb';
import Mohave from './Mohave';
import Yuzu from './Yuzu';
import Footer from './Footer';

// Game tile image mapping
const tileImages = {
  2: tile1,
  4: tile2,
  8: tile3,
  16: tile4,
  32: tile5,
  64: tile6,
  128: tile7,
  256: tile8,
  512: tile9,
  1024: tile10,
  2048: tile11
};

// Sound functions
const playMoveSound = () => {
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  const oscillator = audioContext.createOscillator();
  const gainNode = audioContext.createGain();

  oscillator.connect(gainNode);
  gainNode.connect(audioContext.destination);

  oscillator.frequency.setValueAtTime(200, audioContext.currentTime);
  gainNode.gain.setValueAtTime(0.1, audioContext.currentTime);
  gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.1);

  oscillator.start(audioContext.currentTime);
  oscillator.stop(audioContext.currentTime + 0.1);
};

const playMergeSound = () => {
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  const oscillator = audioContext.createOscillator();
  const gainNode = audioContext.createGain();

  oscillator.connect(gainNode);
  gainNode.connect(audioContext.destination);

  oscillator.frequency.setValueAtTime(400, audioContext.currentTime);
  oscillator.frequency.exponentialRampToValueAtTime(600, audioContext.currentTime + 0.2);
  gainNode.gain.setValueAtTime(0.2, audioContext.currentTime);
  gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.2);

  oscillator.start(audioContext.currentTime);
  oscillator.stop(audioContext.currentTime + 0.2);
};

// Game logic functions
const addRandomTile = (board) => {
  const emptyCells = [];
  for (let i = 0; i < 4; i++) {
    for (let j = 0; j < 4; j++) {
      if (board[i][j] === 0) {
        emptyCells.push([i, j]);
      }
    }
  }
  if (emptyCells.length > 0) {
    const randomCell = emptyCells[Math.floor(Math.random() * emptyCells.length)];
    board[randomCell[0]][randomCell[1]] = Math.random() < 0.9 ? 2 : 4;
  }
};

const initializeBoard = () => {
  const board = Array(4).fill(null).map(() => Array(4).fill(0));
  addRandomTile(board);
  addRandomTile(board);
  return board;
};

const canMove = (board) => {
  for (let i = 0; i < 4; i++) {
    for (let j = 0; j < 4; j++) {
      if (board[i][j] === 0) return true;
    }
  }

  for (let i = 0; i < 4; i++) {
    for (let j = 0; j < 4; j++) {
      if (j < 3 && board[i][j] === board[i][j + 1]) return true;
      if (i < 3 && board[i][j] === board[i + 1][j]) return true;
    }
  }

  return false;
};

function App() {
  const [gameBoard, setGameBoard] = useState(initializeBoard);
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const [animatingCells, setAnimatingCells] = useState([]);
  const [gameStarted, setGameStarted] = useState(false);
  const [lightboxImage, setLightboxImage] = useState(null);

  // Gallery carousel state
  const [currentGalleryIndex, setCurrentGalleryIndex] = useState(0);

  const galleryItems = [
    { src: mapiGallery, title: 'Mapi', description: 'DePIN Developer Platform', link: '/mapiweb' },
    { src: mapiGallery2, title: 'Mapi mobile', description: 'DePIN Developer Platform', link: '/mapi' },
    { src: yuzuGallery, title: 'Yuzu City', description: 'TON Blockchain Gaming Platform', link: '/yuzu' },
    { src: mohaveGallery, title: 'Mohave Pro', description: 'Automotive Community App', link: '/mohave' }
  ];

  // Create extended array for carousel
  const createGalleryArray = () => {
    const multiplier = 3;
    const result = [];
    for (let i = 0; i < galleryItems.length * multiplier; i++) {
      result.push(galleryItems[i % galleryItems.length]);
    }
    return result;
  };

  const displayGalleryItems = createGalleryArray();

  // Slide transition handling
  useEffect(() => {
    if (currentGalleryIndex >= galleryItems.length * 2) {
      const timeout = setTimeout(() => {
        setCurrentGalleryIndex(galleryItems.length);
      }, 0);
      return () => clearTimeout(timeout);
    }
    if (currentGalleryIndex < galleryItems.length) {
      const timeout = setTimeout(() => {
        setCurrentGalleryIndex(galleryItems.length + currentGalleryIndex);
      }, 0);
      return () => clearTimeout(timeout);
    }
  }, [currentGalleryIndex, galleryItems.length]);

  const handleGalleryPrev = () => {
    if (currentGalleryIndex > galleryItems.length) {
      setCurrentGalleryIndex(prev => prev - 1);
    }
  };

  const handleGalleryNext = () => {
    if (currentGalleryIndex < galleryItems.length * 2 - 1) {
      setCurrentGalleryIndex(prev => prev + 1);
    }
  };

  const itemWidth = 100 / 3.125; // 3 + 1/8 = 3.125
  const translateX = -(currentGalleryIndex + 0.125) * itemWidth;

  // Calculate progress
  const progress = ((currentGalleryIndex % galleryItems.length) / (galleryItems.length - 1)) * 100;

  // Check navigation availability
  const canGoPrev = currentGalleryIndex > galleryItems.length;
  const canGoNext = currentGalleryIndex < galleryItems.length * 2 - 1;

  const downloadResume = () => {
    const link = document.createElement('a');
    link.href = resumePDF;
    link.download = 'Dzhevelik_CV.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openLightbox = (imageSrc) => {
    setLightboxImage(imageSrc);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxImage(null);
    document.body.style.overflow = 'auto';
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        closeLightbox();
      }
    };

    if (lightboxImage) {
      window.addEventListener('keydown', handleEscape);
    }

    return () => {
      window.removeEventListener('keydown', handleEscape);
    };
  }, [lightboxImage]);

  const animateNewTile = (row, col) => {
    const newAnimation = { row, col, type: 'new' };
    setAnimatingCells(prev => [...prev, newAnimation]);
    setTimeout(() => {
      setAnimatingCells(prev => prev.filter(anim => !(anim.row === row && anim.col === col && anim.type === 'new')));
    }, 600);
  };

  const animateMerge = (row, col) => {
    const mergeAnimation = { row, col, type: 'merge' };
    setAnimatingCells(prev => [...prev, mergeAnimation]);
    setTimeout(() => {
      setAnimatingCells(prev => prev.filter(anim => !(anim.row === row && anim.col === col && anim.type === 'merge')));
    }, 400);
  };

  const moveLeft = () => {
    if (!gameStarted) setGameStarted(true);

    let newBoard = gameBoard.map(row => [...row]);
    let moved = false;
    let newScore = score;
    let hasMerged = false;

    for (let i = 0; i < 4; i++) {
      let row = newBoard[i].filter(cell => cell !== 0);

      for (let j = 0; j < row.length - 1; j++) {
        if (row[j] === row[j + 1]) {
          row[j] *= 2;
          newScore += row[j];
          row.splice(j + 1, 1);
          hasMerged = true;
          setTimeout(() => animateMerge(i, j), 50);
        }
      }

      while (row.length < 4) {
        row.push(0);
      }

      for (let j = 0; j < 4; j++) {
        if (newBoard[i][j] !== row[j]) {
          moved = true;
        }
        newBoard[i][j] = row[j];
      }
    }

    if (moved) {
      const oldBoard = [...gameBoard];
      addRandomTile(newBoard);

      for (let i = 0; i < 4; i++) {
        for (let j = 0; j < 4; j++) {
          if (oldBoard[i][j] === 0 && newBoard[i][j] !== 0) {
            setTimeout(() => animateNewTile(i, j), 100);
          }
        }
      }

      setGameBoard(newBoard);
      setScore(newScore);

      if (hasMerged) {
        playMergeSound();
      } else {
        playMoveSound();
      }

      if (!canMove(newBoard)) {
        setGameOver(true);
      }
    }
  };

  const moveRight = () => {
    if (!gameStarted) setGameStarted(true);

    let newBoard = gameBoard.map(row => [...row]);
    let moved = false;
    let newScore = score;
    let hasMerged = false;

    for (let i = 0; i < 4; i++) {
      let row = newBoard[i].filter(cell => cell !== 0);

      for (let j = row.length - 1; j > 0; j--) {
        if (row[j] === row[j - 1]) {
          row[j] *= 2;
          newScore += row[j];
          row.splice(j - 1, 1);
          j--;
          hasMerged = true;
          setTimeout(() => animateMerge(i, 4 - row.length + j), 50);
        }
      }

      while (row.length < 4) {
        row.unshift(0);
      }

      for (let j = 0; j < 4; j++) {
        if (newBoard[i][j] !== row[j]) {
          moved = true;
        }
        newBoard[i][j] = row[j];
      }
    }

    if (moved) {
      const oldBoard = [...gameBoard];
      addRandomTile(newBoard);

      for (let i = 0; i < 4; i++) {
        for (let j = 0; j < 4; j++) {
          if (oldBoard[i][j] === 0 && newBoard[i][j] !== 0) {
            setTimeout(() => animateNewTile(i, j), 100);
          }
        }
      }

      setGameBoard(newBoard);
      setScore(newScore);

      if (hasMerged) {
        playMergeSound();
      } else {
        playMoveSound();
      }

      if (!canMove(newBoard)) {
        setGameOver(true);
      }
    }
  };

  const moveUp = () => {
    if (!gameStarted) setGameStarted(true);

    let newBoard = gameBoard.map(row => [...row]);
    let moved = false;
    let newScore = score;
    let hasMerged = false;

    for (let j = 0; j < 4; j++) {
      let column = [];
      for (let i = 0; i < 4; i++) {
        if (newBoard[i][j] !== 0) {
          column.push(newBoard[i][j]);
        }
      }

      for (let i = 0; i < column.length - 1; i++) {
        if (column[i] === column[i + 1]) {
          column[i] *= 2;
          newScore += column[i];
          column.splice(i + 1, 1);
          hasMerged = true;
          setTimeout(() => animateMerge(i, j), 50);
        }
      }

      while (column.length < 4) {
        column.push(0);
      }

      for (let i = 0; i < 4; i++) {
        if (newBoard[i][j] !== column[i]) {
          moved = true;
        }
        newBoard[i][j] = column[i];
      }
    }

    if (moved) {
      const oldBoard = [...gameBoard];
      addRandomTile(newBoard);

      for (let i = 0; i < 4; i++) {
        for (let j = 0; j < 4; j++) {
          if (oldBoard[i][j] === 0 && newBoard[i][j] !== 0) {
            setTimeout(() => animateNewTile(i, j), 100);
          }
        }
      }

      setGameBoard(newBoard);
      setScore(newScore);

      if (hasMerged) {
        playMergeSound();
      } else {
        playMoveSound();
      }

      if (!canMove(newBoard)) {
        setGameOver(true);
      }
    }
  };

  const moveDown = () => {
    if (!gameStarted) setGameStarted(true);

    let newBoard = gameBoard.map(row => [...row]);
    let moved = false;
    let newScore = score;
    let hasMerged = false;

    for (let j = 0; j < 4; j++) {
      let column = [];
      for (let i = 0; i < 4; i++) {
        if (newBoard[i][j] !== 0) {
          column.push(newBoard[i][j]);
        }
      }

      for (let i = column.length - 1; i > 0; i--) {
        if (column[i] === column[i - 1]) {
          column[i] *= 2;
          newScore += column[i];
          column.splice(i - 1, 1);
          i--;
          hasMerged = true;
          setTimeout(() => animateMerge(4 - column.length + i, j), 50);
        }
      }

      while (column.length < 4) {
        column.unshift(0);
      }

      for (let i = 0; i < 4; i++) {
        if (newBoard[i][j] !== column[i]) {
          moved = true;
        }
        newBoard[i][j] = column[i];
      }
    }

    if (moved) {
      const oldBoard = [...gameBoard];
      addRandomTile(newBoard);

      for (let i = 0; i < 4; i++) {
        for (let j = 0; j < 4; j++) {
          if (oldBoard[i][j] === 0 && newBoard[i][j] !== 0) {
            setTimeout(() => animateNewTile(i, j), 100);
          }
        }
      }

      setGameBoard(newBoard);
      setScore(newScore);

      if (hasMerged) {
        playMergeSound();
      } else {
        playMoveSound();
      }

      if (!canMove(newBoard)) {
        setGameOver(true);
      }
    }
  };

  const newGame = () => {
    setGameBoard(initializeBoard());
    setScore(0);
    setGameOver(false);
    setAnimatingCells([]);
    setGameStarted(false);
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (gameOver) return;

      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          moveLeft();
          break;
        case 'ArrowRight':
          e.preventDefault();
          moveRight();
          break;
        case 'ArrowUp':
          e.preventDefault();
          moveUp();
          break;
        case 'ArrowDown':
          e.preventDefault();
          moveDown();
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [gameBoard, gameOver]);

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-content">
          <div className="header-left">
            <Link to="/">
              <img src={headerLogo} alt="Logo" className="logo" />
            </Link>
          </div>
          <nav className="header-right">
            <ul className="nav-links">
              <li><Link to="/">Projects</Link></li>
              <li><a href="#about">About</a></li>
              <li>
                <a href="#resume" onClick={(e) => { e.preventDefault(); downloadResume(); }}>
                  Resume
                </a>
              </li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </nav>
        </div>
      </header>

      <Routes>
        <Route path="/" element={
          <>
            <main className="App-main" style={{backgroundImage: `url(${mainBack})`}}>
              <div className="content">
                <section className="main-section">
                  <div className="main-background">
                    <img src={portfolioImage} alt="Portfolio" className="portfolio-image" />
                  </div>
                </section>

                {/* Gallery Carousel Section */}
                <section className="gallery-carousel-section">
                  <div className="gallery-carousel">
                    <div className="gallery-carousel-container">
                      <div
                        className="gallery-carousel-track"
                        style={{ transform: `translateX(${translateX}%)` }}
                      >
                        {displayGalleryItems.map((item, index) => (
                          <div key={index} className="gallery-carousel-item">
                            <Link to={item.link}>
                              <img src={item.src} alt={item.title} className="gallery-carousel-image" />
                            </Link>
                            <h3 className="gallery-carousel-title">{item.title}</h3>
                            <p className="gallery-carousel-description">{item.description}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Navigation Controls */}
                  <div className="gallery-carousel-controls">
                    <button
                      className="gallery-carousel-arrow gallery-carousel-arrow-left"
                      onClick={handleGalleryPrev}
                    >
                      <img
                        src={canGoPrev ? leftArrowActive : leftArrowInactive}
                        alt="Previous"
                        className="arrow-icon"
                      />
                    </button>

                    <div className="gallery-carousel-progress">
                      <div className="gallery-carousel-progress-bg"></div>
                      <div
                        className="gallery-carousel-progress-fill"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>

                    <button
                      className="gallery-carousel-arrow gallery-carousel-arrow-right"
                      onClick={handleGalleryNext}
                    >
                      <img
                        src={canGoNext ? leftArrowActive : leftArrowInactive}
                        alt="Next"
                        className="arrow-icon arrow-icon-right"
                      />
                    </button>
                  </div>
                </section>

                <section className="about-section" id="about">
                  <div className="about-content">
                    <div className="about-left">
                      <img src={aboutMeImage} alt="About Me" className="about-image" />
                      <div className="about-text">
                        <h2 className="about-title">Hi, my name is Anastasiia</h2>
                        <p className="about-description">
                          I'm a UI/UX designer who transforms complex technical challenges into seamless user experiences. With 4+ years of international client work, <br /> I specialize in bridging the gap between ambitious product visions and practical implementation, delivering designs that users love and developers can build efficiently.
                        </p>
                      </div>
                    </div>
                    <div className="about-right">
                      <div className="game-header">
                        <div className="score">Score: {score}</div>
                        <button onClick={newGame} className="new-game-btn">
                          <img src={topNewGame} alt="New Game" />
                        </button>
                      </div>
                      <div className="game-2048">
                        <img src={back2048} alt="2048 Background" className="game-background" />

                        {!gameStarted && (
                          <div className="press-to-play">
                            <img src={pressToPlay} alt="Press to play" />
                          </div>
                        )}

                        <div className="game-grid">
                          {gameBoard.map((row, rowIndex) =>
                            row.map((cell, colIndex) => (
                              <div
                                key={`${rowIndex}-${colIndex}`}
                                className={`game-cell ${
                                  animatingCells.some(anim => anim.row === rowIndex && anim.col === colIndex && anim.type === 'new')
                                    ? 'animate-new'
                                    : animatingCells.some(anim => anim.row === rowIndex && anim.col === colIndex && anim.type === 'merge')
                                    ? 'animate-merge'
                                    : ''
                                }`}
                              >
                                {cell !== 0 && (
                                  <img
                                    src={tileImages[cell]}
                                    alt={`Tile ${cell}`}
                                    className="tile-image"
                                  />
                                )}
                              </div>
                            ))
                          )}
                        </div>
                        {gameOver && (
                          <div className="game-over">
                            <div className="game-over-content">
                              <div className="game-over-text">Game Over</div>
                              <div className="game-over-score">Your score: {score}</div>
                              <button onClick={newGame} className="restart-btn">
                                Restart <span className="restart-icon">?</span>
                              </button>
                            </div>
                          </div>
                        )}
                        <div className="game-instructions">
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </main>
            <Footer />
          </>
        } />
        <Route path="/mapi" element={<Mapi />} />
        <Route path="/mapiweb" element={<MapiWeb />} />
        <Route path="/mohave" element={<Mohave />} />
        <Route path="/yuzu" element={<Yuzu />} />
      </Routes>

      {lightboxImage && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>?</button>
            <img src={lightboxImage} alt="Gallery" className="lightbox-image" />
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
